var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.076,
    height: 105.894,
    viewBox: "0 0 123.076 105.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_25813",
    x: 9.885,
    y: 29.881,
    width: 53.605,
    height: 45.222,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25835",
    "data-name": "Rect\\xE1ngulo 25835",
    width: 17.699,
    height: 17.336,
    fill: "#ed92c8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25836",
    "data-name": "Rect\\xE1ngulo 25836",
    width: 68.587,
    height: 48.194,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20995",
    "data-name": "Trazado 20995",
    d: "M45.454,20.449V62.807a4.024,4.024,0,0,0,4.024,4.024H80.5V20.449Z",
    transform: "translate(-45.454 -20.449)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42753",
    "data-name": "Grupo 42753",
    transform: "translate(-176.605 -1042.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20914",
    "data-name": "Trazado 20914",
    d: "M303.41,1006.538a52.947,52.947,0,1,1-52.947-52.947,52.947,52.947,0,0,1,52.947,52.947",
    transform: "translate(-20.91 88.625)",
    fill: "#ed92c8",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42733",
    "data-name": "Grupo 42733",
    transform: "translate(195.49 1066.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42584",
    "data-name": "Grupo 42584",
    transform: "translate(0 11.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42581",
    "data-name": "Grupo 42581",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42578",
    "data-name": "Grupo 42578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.88, -35.88)",
    filter: "url(#Rect\\xE1ngulo_25813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25813-2",
    "data-name": "Rect\\xE1ngulo 25813",
    width: 27.222,
    height: 35.606,
    transform: "translate(18.88 63.1) rotate(-90)",
    fill: "#e149a4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42583",
    "data-name": "Grupo 42583",
    transform: "translate(0.209 9.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42582",
    "data-name": "Grupo 42582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20972",
    "data-name": "Trazado 20972",
    d: "M17.7,17.336H0L1.362,11.7l.191-.782a2.251,2.251,0,0,1,2.182-1.7H6.176c.073,0,.807-.063.807-1.144V3.693l.006-.706A3.011,3.011,0,0,1,10.141,0c2.6,0,3.175,3.093,3.175,3.093l.393,1.891h-.885V6.966a.543.543,0,0,1-.544.543H10.863v.837s0,.874.807.874h2.288a2.256,2.256,0,0,1,2.183,1.7l.215.863Z",
    fill: "#ed92c8"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    "data-name": "L\\xEDnea 15",
    x2: 27.945,
    transform: "translate(5.099 5.564)",
    fill: "none",
    stroke: "#ed92c8",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    x2: 14.904,
    transform: "translate(17.675 12.085)",
    fill: "none",
    stroke: "#f2b1d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_17",
    "data-name": "L\\xEDnea 17",
    x2: 14.438,
    transform: "translate(17.675 14.414)",
    fill: "none",
    stroke: "#f2b1d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    x2: 14.438,
    transform: "translate(17.675 16.742)",
    fill: "none",
    stroke: "#f2b1d8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42591",
    "data-name": "Grupo 42591",
    transform: "translate(35.606 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42586",
    "data-name": "Grupo 42586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42585",
    "data-name": "Grupo 42585",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20973",
    "data-name": "Trazado 20973",
    d: "M430.771,135.084h-1.415a.293.293,0,0,1-.293-.293V96.261h3.956v36.575a2.249,2.249,0,0,1-2.249,2.249",
    transform: "translate(-391.053 -87.733)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20974",
    "data-name": "Trazado 20974",
    d: "M46.923,30.4H81.97V75.017H51.32a4.34,4.34,0,0,1-4.4-4.28Z",
    transform: "translate(-42.766 -27.705)",
    fill: "#f8f6f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42588",
    "data-name": "Grupo 42588",
    transform: "translate(4.027 1.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42587",
    "data-name": "Grupo 42587",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20975",
    "data-name": "Trazado 20975",
    d: "M52.767,19.825l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-45.821 -16.044)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20976",
    "data-name": "Trazado 20976",
    d: "M76.605,19.931l3.172,3.456-5.051-.164L69.7,24.342,72.754,20.3l1.859-4.574Z",
    transform: "translate(-67.548 -16.141)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20977",
    "data-name": "Trazado 20977",
    d: "M102.855,20.048l3.172,3.456-5.051-.164-5.031,1.118L99,20.413l1.859-4.574Z",
    transform: "translate(-91.473 -16.247)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20978",
    "data-name": "Trazado 20978",
    d: "M129.881,20.169l3.172,3.456L128,23.461l-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-116.104 -16.357)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20979",
    "data-name": "Trazado 20979",
    d: "M6.91,19.621l3.172,3.456-5.051-.164L0,24.031l3.058-4.046,1.859-4.574Z",
    transform: "translate(-4.027 -15.858)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20980",
    "data-name": "Trazado 20980",
    d: "M33.935,19.741,37.107,23.2l-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-28.658 -15.967)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20981",
    "data-name": "Trazado 20981",
    d: "M250.143,20.7l3.172,3.456L248.265,24l-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-225.713 -16.845)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20982",
    "data-name": "Trazado 20982",
    d: "M273.982,20.811l3.172,3.456L272.1,24.1l-5.031,1.118,3.058-4.046L271.99,16.6Z",
    transform: "translate(-247.44 -16.942)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20983",
    "data-name": "Trazado 20983",
    d: "M300.232,20.927l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-271.364 -17.048)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20984",
    "data-name": "Trazado 20984",
    d: "M327.258,21.048,330.43,24.5l-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-295.996 -17.158)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20985",
    "data-name": "Trazado 20985",
    d: "M154.2,20.277l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-138.267 -16.456)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20986",
    "data-name": "Trazado 20986",
    d: "M178.036,20.383l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-159.994 -16.552)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20987",
    "data-name": "Trazado 20987",
    d: "M204.287,20.5l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-183.919 -16.659)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20988",
    "data-name": "Trazado 20988",
    d: "M231.312,20.621l3.172,3.456-5.051-.164L224.4,25.031l3.058-4.046,1.859-4.574Z",
    transform: "translate(-208.55 -16.769)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20989",
    "data-name": "Trazado 20989",
    d: "M472.062,4.085l3.081,3.346-4.929-.137L465.3,8.4l3-3.947L470.136,0Z",
    transform: "translate(-428.104 -1.812)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20990",
    "data-name": "Trazado 20990",
    d: "M306.778,40.907l1.906,2.077-3.035-.1-3.023.672,1.838-2.431,1.117-2.748Z",
    transform: "translate(-279.844 -36.789)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20991",
    "data-name": "Trazado 20991",
    d: "M356.839,21.18l3.172,3.456-5.051-.164-5.031,1.118,3.058-4.046,1.859-4.574Z",
    transform: "translate(-322.956 -17.278)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20992",
    "data-name": "Trazado 20992",
    d: "M380.677,21.286l3.172,3.456-5.051-.164L373.768,25.7l3.058-4.046,1.859-4.574Z",
    transform: "translate(-344.683 -17.375)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20993",
    "data-name": "Trazado 20993",
    d: "M427.3,4.085l3.081,3.346-4.929-.137L420.539,8.4l3-3.947L425.378,0Z",
    transform: "translate(-387.311 -1.812)",
    fill: "#f8f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20994",
    "data-name": "Trazado 20994",
    d: "M453.681,4.085l3.081,3.346-4.929-.137L446.917,8.4l3-3.947L451.756,0Z",
    transform: "translate(-411.352 -1.812)",
    fill: "#f8f6f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42590",
    "data-name": "Grupo 42590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42589",
    "data-name": "Grupo 42589",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25837",
    "data-name": "Rect\\xE1ngulo 25837",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 9.874)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25838",
    "data-name": "Rect\\xE1ngulo 25838",
    width: 10.933,
    height: 1.627,
    transform: "translate(7.984 22.751)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25839",
    "data-name": "Rect\\xE1ngulo 25839",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 14.177)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25840",
    "data-name": "Rect\\xE1ngulo 25840",
    width: 10.933,
    height: 1.627,
    transform: "translate(7.984 27.055)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25841",
    "data-name": "Rect\\xE1ngulo 25841",
    width: 10.933,
    height: 1.629,
    transform: "translate(23.481 18.481)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25842",
    "data-name": "Rect\\xE1ngulo 25842",
    width: 10.933,
    height: 1.629,
    transform: "translate(7.984 31.359)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25843",
    "data-name": "Rect\\xE1ngulo 25843",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 22.785)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25844",
    "data-name": "Rect\\xE1ngulo 25844",
    width: 10.933,
    height: 1.627,
    transform: "translate(7.984 35.662)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25845",
    "data-name": "Rect\\xE1ngulo 25845",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 26.935)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25846",
    "data-name": "Rect\\xE1ngulo 25846",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 31.239)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25847",
    "data-name": "Rect\\xE1ngulo 25847",
    width: 10.933,
    height: 1.627,
    transform: "translate(23.481 35.148)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25848",
    "data-name": "Rect\\xE1ngulo 25848",
    width: 10.933,
    height: 1.627,
    transform: "translate(8.028 39.372)",
    fill: "#c4c6c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25849",
    "data-name": "Rect\\xE1ngulo 25849",
    width: 10.844,
    height: 13.086,
    transform: "translate(8.05 7.685)",
    fill: "#e0e1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20996",
    "data-name": "Trazado 20996",
    d: "M393.263,468.16s-.449,7.072,1.067,5.81h-5.856Z",
    transform: "translate(-354.059 -426.686)",
    fill: "#f8f6f6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42580",
    "data-name": "Grupo 42580",
    transform: "translate(21.89 31.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25832",
    "data-name": "Rect\\xE1ngulo 25832",
    width: 13.507,
    height: 36.329,
    transform: "translate(4.192 0.233)",
    fill: "#fcedf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20970",
    "data-name": "Trazado 20970",
    d: "M2961,466l9.513,4.761V502.64H2961Z",
    transform: "translate(-2956.993 -466)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20971",
    "data-name": "Trazado 20971",
    d: "M-.179-.071.5,1.115V32.029h-.62Z",
    transform: "translate(13.816 4.61)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25833",
    "data-name": "Rect\\xE1ngulo 25833",
    width: 13.973,
    height: 36.795,
    transform: "translate(0 4.425)",
    fill: "#fcedf6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25834",
    "data-name": "Rect\\xE1ngulo 25834",
    width: 9.781,
    height: 11.644,
    transform: "translate(2.329 7.219)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_10",
    "data-name": "L\\xEDnea 10",
    x2: 8.587,
    transform: "translate(3.149 21.468)",
    fill: "none",
    stroke: "#e149a4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_11",
    "data-name": "L\\xEDnea 11",
    x2: 8.587,
    transform: "translate(3.149 23.758)",
    fill: "none",
    stroke: "#e149a4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_12",
    "data-name": "L\\xEDnea 12",
    x2: 8.587,
    transform: "translate(3.149 26.621)",
    fill: "none",
    stroke: "#e149a4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_13",
    "data-name": "L\\xEDnea 13",
    x2: 8.587,
    transform: "translate(3.149 28.911)",
    fill: "none",
    stroke: "#e149a4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_14",
    "data-name": "L\\xEDnea 14",
    x2: 8.015,
    transform: "translate(3.149 31.201)",
    fill: "none",
    stroke: "#e149a4",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMi);
export default __webpack_public_path__ + "static/media/Login_MI.668fd71e0f0f8b606d4302adf2da7849.svg";
export { ForwardRef as ReactComponent };